/**
 * Fixed page sizes offered by the Prev/Next pager. There is no "all"
 * option: the table pages the backend with `skip`/`limit` rather than
 * loading the full result set client-side.
 */
export type RevenueAnalyticsRowsPerPage = 25 | 50 | 100;

export const REVENUE_ANALYTICS_PAGE_SIZE_OPTIONS: readonly RevenueAnalyticsRowsPerPage[] = [25, 50, 100];

export const DEFAULT_REVENUE_ANALYTICS_ROWS_PER_PAGE: RevenueAnalyticsRowsPerPage = 50;

export interface RevenueAnalyticsState {
    /** Firm scope for the provider list; `undefined` = superuser "all firms". */
    readonly firmId: string | undefined;
    /** Superuser mode; enables the provider list even without a firm scope. */
    readonly superUserMode: boolean;
    /** Selected provider id; `''` when none is chosen. */
    readonly selectedProviderId: string;
    /** Live text in the symbol search box. */
    readonly symbolSearchInput: string;
    /** Committed symbol term sent to the backend; `''` when search is inactive. */
    readonly appliedSymbolSearch: string;
    /** 1-based page index used to derive `skip`. */
    readonly page: number;
    readonly rowsPerPage: RevenueAnalyticsRowsPerPage;
}

export const initialRevenueAnalyticsState: RevenueAnalyticsState = {
    firmId: undefined,
    superUserMode: false,
    selectedProviderId: '',
    symbolSearchInput: '',
    appliedSymbolSearch: '',
    page: 1,
    rowsPerPage: DEFAULT_REVENUE_ANALYTICS_ROWS_PER_PAGE,
};
